import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import BackToTop from "./elements/back-top";
import PageScrollTop from "./elements/page-scroll-top";
import Index3 from "./pages/index-3";
import About1 from "./pages/about-1";
import Newsletters2025 from "./pages/newsletters-2025";
import NewslettersBefore2024 from "./pages/newsletters-before-2024";
import Photos from "./pages/photos";
import Videos from "./pages/videos";
import News0 from "./pages/news-0";
import News1 from "./pages/news-1";
import News2 from "./pages/news-2";
import News3 from "./pages/news-3";
import News4 from "./pages/news-4";
import News5 from "./pages/news-5";
import News6 from "./pages/news-6";
import News7 from "./pages/news-7";
import News8 from "./pages/news-8";
import News9 from "./pages/news-9";
import News10 from "./pages/news-10";
import News11 from "./pages/news-11";
import News12 from "./pages/news-12";
import News13 from "./pages/news-13";
import News14 from "./pages/news-14";
import News15 from "./pages/news-15";
import News16 from "./pages/news-16";
import News17 from "./pages/news-17";
import News18 from "./pages/news-18";
import IOAIIntroduction from "./pages/ioai-introduction";
import IOAIResource from "./pages/ioai-resource";
import IOAIApplication from "./pages/ioai-application";
import IOAIJourney from "./pages/ioai-journey";
import AOAITeam from "./pages/aoai-team";
import IOAISponsor from "./pages/aoai-sponsor";
import CoursesDetails from "./pages/courses-details";
import Contact2 from "./pages/contact-2";
import ParentQAndA from "./pages/parent-q-and-a";
import BecomeOurStudentsSA from "./pages/become-our-students-sa";
import BecomeOurStudentsQLD from "./pages/become-our-students-qld";
import BecomeOurTeachers from "./pages/become-our-teachers";
import BecomeOurPartners from "./pages/become-our-partners";
import BecomeOurStudentsCA from "./pages/become-our-students-ca";

class Markup extends Component {
	componentDidMount() {
		
	} 
	render() {
		return (
			<>
				<BrowserRouter basename={"/"}>
					<Switch>
						<Route path="/" exact component={Index3} />
						<Route path="/courses-details" exact component={CoursesDetails} />
						<Route path="/news-0" exact component={News0} />
						<Route path="/news-1" exact component={News1} />
						<Route path="/news-2" exact component={News2} />
						<Route path="/news-3" exact component={News3} />
						<Route path="/news-4" exact component={News4} />
						<Route path="/news-5" exact component={News5} />
						<Route path="/news-6" exact component={News6} />
						<Route path="/news-7" exact component={News7} />
						<Route path="/news-8" exact component={News8} />
						<Route path="/news-9" exact component={News9} />
						<Route path="/news-10" exact component={News10} />
						<Route path="/news-11" exact component={News11} />
						<Route path="/news-12" exact component={News12} />
						<Route path="/news-13" exact component={News13} />
						<Route path="/news-14" exact component={News14} />
						<Route path="/news-15" exact component={News15} />
						<Route path="/news-16" exact component={News16} />
						<Route path="/news-17" exact component={News17} />
						<Route path="/news-18" exact component={News18} />
						<Route path="/ioai-introduction" exact component={IOAIIntroduction} />
						<Route path="/ioai-resource" exact component={IOAIResource} />
						<Route path="/aoai-sponsor" exact component={IOAISponsor} />
						<Route path="/ioai-application" exact component={IOAIApplication} />
						<Route path="/ioai-journey" exact component={IOAIJourney} />
						<Route path="/aoai-team" exact component={AOAITeam} />
						<Route path="/photos" exact component={Photos} />
						<Route path="/videos" exact component={Videos} />
						<Route path="/about" exact component={About1} />
						<Route path="/newsletters-2025" exact component={Newsletters2025} />
						<Route path="/newsletters-before-2024" exact component={NewslettersBefore2024} />
						<Route path="/parent-q-and-a" exact component={ParentQAndA} />
						<Route path="/contact" exact component={Contact2} />
						<Route path="/become-our-students-sa" exact component={BecomeOurStudentsSA} />
						<Route path="/become-our-students-qld" exact component={BecomeOurStudentsQLD} />
						<Route path="/become-our-students-ca" exact component={BecomeOurStudentsCA} />
						<Route path="/become-our-teachers" exact component={BecomeOurTeachers} />
						<Route path="/become-our-partners" exact component={BecomeOurPartners} />
					</Switch>		
					<div className="section-area section-sp3">
						<div className="col-md-12 heading-bx style1 text-center">
							<b>© Leading Coding</b>
							<br/>
							Website Content Design and Development by L&C Information Technology and Education
						</div>
					</div>
					<PageScrollTop />
				</BrowserRouter>
				<BackToTop />
			</>
		);
	}
}

export default Markup;
